import { Injectable, OnInit } from '../ng';
import * as Data from '../data';
import { CommandSecurityCheckpointDto, ValueTextDto } from '../data/CommandServiceDtos.generated';
import * as _ from 'lodash'

@Injectable()
export class ClientSessionService implements OnInit {
  private loginSubscribers: Function[] = [];
  private resetSubscribers: Function[] = [];
  private emptyUserInfo: Data.Web.UserInfoDto = {
    Id: 0,
    UserName: "",
    FirstName: "",
    LastName: "",
    Roles: [],
    EmailAddress: "",
    LogCommands: false,
    Checkpoints: []
  }

  subscribeToLogin(callback: Function) {
    this.loginSubscribers.push(callback);
  }
  subscribeToReset(callback: Function) {
    this.resetSubscribers.push(callback);
  }

  get userInfo(): Data.Web.UserInfoDto {
    var result = this.emptyUserInfo;
    var jsonData = window.localStorage.getItem("userInfo");
    if (jsonData != null) {
      result = JSON.parse(jsonData);
    }

    return result;
  }
  set userInfo(value: Data.Web.UserInfoDto) {
    var jsonData = JSON.stringify(value);
    window.localStorage.setItem("userInfo", jsonData);
  }

  loginUser(userInfoDto: Data.Web.UserInfoDto) {
    this.userInfo = userInfoDto;
    for (let i = 0; i < this.loginSubscribers.length; i++) {
      this.loginSubscribers[i]();
    }
  }


  constructor(
  ) {
  }

  get loggedIn() {
    var result = this.userInfo.Id > 0;
    return result;
  }


  public reset() {
    window.localStorage.removeItem("userInfo");
    for (let i = 0; i < this.resetSubscribers.length; i++) {
      this.resetSubscribers[i]();
    }
  }

  ngOnInit() {

  }

  private initialize() {
  }

  get userName(): string {
    if (this.userInfo)
      return this.userInfo.UserName;
    else
      return "";
  }

  get userId(): number {
    if (this.userInfo)
      return this.userInfo.Id;
    else
      return 0;
  }

  get roles(): ValueTextDto[] {
    if (this.userInfo)
      return this.userInfo.Roles;
    else
      return [];
  }

  get isAdmin(): boolean {
    var result = this.roles.filter((item) => { return item.Text == 'Admin' || item.Text == 'Global Administrator' }).length > 0;
    return result;
  }

  public isInRoleName(role: string): boolean {
    var result = this.roles.filter((item) => { return item.Text == role }).length > 0;
    return result;
  }

  public isInRoleId(roleId: number): boolean {
    var result = this.roles.filter((item) => { return item.Value == roleId }).length > 0;
    return result;
  }

  get firstName(): string {
    if (this.userInfo)
      return this.userInfo.FirstName;
    else
      return "";
  }

  get lastName(): string {
    if (this.userInfo)
      return this.userInfo.LastName;
    else
      return "";
  }

  checkpoint(commandName: string): boolean {
    var result = _.some(this.userInfo.Checkpoints, (value: CommandSecurityCheckpointDto) => {
      return value.CommandName == commandName && value.HasAccess;
    });
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/client-session.service.ts